(function(SCS) {
	'use strict';

	// jshint maxparams: 10

	var search = SCS.search = SCS.search || {};
	var plugins = search.plugins = search.plugins || {};

	function baseSetup(urlPrefix, suffix, backendType, defaultConfig, customConfig) {
		urlPrefix = urlPrefix || '';
		// Create processor (use global backend)
		var processor = new search.Processor();

		var url = plugins.url;
		// Add URL handling
		url.setUp(
			processor,
			null,
			url.setBaseURL(urlPrefix, '/' + suffix, backendType),
			url.addDefaultConfig(
				defaultConfig,
				customConfig
			),
			url.transposeParams(url.transposeParams.GSA_MAP)
		);

		return processor;
	}

	function gsaSetup(urlPrefix, type, customConfig, sites) {
		var url = plugins.url;
		var gsa = plugins.gsa;

		var defaultConfig = url.addDefaultConfig['GSA_' + type.toUpperCase() + '_CONFIG'] || {};
		var processor = baseSetup(urlPrefix, type, 'gsa', defaultConfig,  customConfig);

		// Add GSA handling (use global session)
		gsa.setUp(processor, gsa.addFilterParams(), gsa.addSiteParams(sites));
		// Add Session handling (use global session)
		plugins.session.setUp(processor);

		return processor;
	}

	function webSetup(urlPrefix, customConfig) {
		var url = plugins.url;
		var gsa = plugins.gsa;
		var web = plugins.web;

		var processor = baseSetup(urlPrefix, 'web/', 'google', url.addDefaultConfig.DEFAULT_QUERY,  customConfig);

		// We use the paging from gsa plugin but not the whole set-up
		processor.usePre(gsa.handlePaging(), 50000);

		web.setUp(processor);

		return processor;
	}

	function forSerp(urlPrefix, site, client, language, customConfig) {
		customConfig = search.util.extend({}, {
			language: language,
			client: client,
			origin: 'serp'
		}, customConfig||{});
		var processor = gsaSetup(urlPrefix, 'search', customConfig, site);

		// Add spell-checking
		plugins.spellchecking.setUp(processor);
		// Add filtering
		plugins.filtering.setUp(processor);
		// Add tracking
		plugins.tracking.setUp(processor);

		return processor;
	}

	function forWebSearch(urlPrefix, language, customConfig) {
		customConfig = search.util.extend({}, {
			language: language,
			origin: 'serp'
		}, customConfig||{});
		var processor = webSetup(urlPrefix, customConfig);

		return processor;
	}

	function split(sites) {
		if(typeof sites === 'string') {
			return sites.split(/\|+/);
		}
		return sites || [];
	}

	function keymatchSetup(urlPrefix, site, client, keyMatchLimit, language, instantCollectionSuffix, customConfig) {
		site = split(site);
		instantCollectionSuffix = instantCollectionSuffix || '';
		for(var i=0;i<site.length;i+=1) {
			site[i] = site[i] + instantCollectionSuffix;
		}
		var config = search.util.extend({
			client: client,
			keyMatchLimit: keyMatchLimit||2,
			language: language,
			resultLimit: 0
		}, customConfig||{});

		return gsaSetup(urlPrefix, 'search', config, site);
	}

	function forKeymatches(urlPrefix, site, client, keyMatchLimit, language, instantCollectionSuffix, customConfig) {
		var processor = keymatchSetup(urlPrefix, site, client, keyMatchLimit, language, instantCollectionSuffix, customConfig);
		// On SERP, do redirect to webcodes
		plugins.keymatch.setUp(processor, null, null, plugins.keymatch.redirectToKeymatch());
		return processor;
	}

	function forAutosuggest(urlPrefix, site, client, suggestionLimit, keyMatchLimit, language, instantCollectionSuffix) {
		language = language || 'de';
		keyMatchLimit = parseInt(keyMatchLimit, 10);

		var processor = gsaSetup(urlPrefix, 'suggest', {
			language: language,
			suggestionLimit: suggestionLimit,
			origin: 'header',
			client: client,
			site: site
		});

		var keymatchProcessor;
		// Only load keymatches if explicitly configured with limit > 0
		if(keyMatchLimit) {
			keymatchProcessor = keymatchSetup(urlPrefix, site, client, keyMatchLimit, language, instantCollectionSuffix, {
				origin: 'header'
			});

			// Don’t redirect to webcodes
			plugins.keymatch.setUp(keymatchProcessor);
		}
		var keymatchRetriever = keymatchProcessor ? plugins.autosuggest.retrieveKeymatchesFromSuggestions(keymatchProcessor) : null;
		plugins.autosuggest.setUp(processor, keymatchRetriever);

		return processor;
	}

	function forClusterSuggestions(urlPrefix, site, client, language) {
		urlPrefix = urlPrefix || '';
		var processor = gsaSetup(urlPrefix, 'cluster', {
			language: language,
			method: 'POST',
			client: client
		}, site);
		return processor;
	}

	function forResultCount(urlPrefix, site, client, language) {
		var processor = gsaSetup(urlPrefix, 'search', {
			language: language,
			client: client,
			proxystylesheet: 'sc_v2_p_json_count',
			gsaFilter: 'duplicateSnippet'
		}, site);

		return processor;
	}

	var orchestration = search.orchestration = search.orchestration || {};

	orchestration.forSerp = forSerp;
	orchestration.forWebSearch = forWebSearch;
	orchestration.forKeymatches = forKeymatches;
	orchestration.forAutosuggest = forAutosuggest;
	orchestration.forClusterSuggestions = forClusterSuggestions;
	orchestration.forResultCount = forResultCount;

})(window.SCS = window.SCS || {});


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/orchestration.js
// module id = 64
// module chunks = 0